import { initAjaxLoadItemsTrigger } from 'allink-core-static/js/modules/ajax-load-items';
import { initMasonry } from 'allink-core-static/js/modules/masonry';

$(function(){

    var options = {
        ajax_load_transition_duration: 100,
    };

    // init modules
    initAjaxLoadItemsTrigger(options);
    initMasonry(options);

    // re-init when softpage has been opened
    $(window).on('softpage:opened',function(){
        initAjaxLoadItemsTrigger(options);
        initMasonry(options);
    });

    // project specifc
    initSpecialAjaxFilter();

});


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Project specific filter

*/

function initSpecialAjaxFilter() {
    // find and loop through filter containers
    let $searchform_input = $('.references-index-plugin__form :input');
    let $filter = $('.special-filter');
    let $form = $('.special-filter__form');
    let $selects = $('.special-filter__select');
    let $ajax_response_container = $('.special-filter-container');
    let ajax_filter_base_url = $filter.attr('data-ajax-filter-base-url');
    // find all selects and loop
    $selects.each(function(){
        // when a filter (select) is changed:
        $(this).change(function(e){
            // combined with categories?
            $form.submit();
        });

    });

    // listen for submit
    $form.on('submit',function(e){
        e.preventDefault();
        let $form = $(e.target);
        loadAjaxSpecial($form, $ajax_response_container, ajax_filter_base_url);
    });
}

function loadAjaxSpecial($form, $ajax_response_container, ajax_filter_base_url) {

    // init
    var postData = $form.serialize();
    var ajax_url = ajax_filter_base_url + '&' + postData;

    $.ajax({
        type: 'GET',
        url: ajax_url,
        contentType: 'application/json',
        success: function(data, textStatus, jqXHR) {
            $('.special-filter__inner').html(data.rendered_filters);
            $('.ajax-items-container').html(data.rendered_content);
            // $ajax_response_container.html(data.rendered_content);
            initSpecialAjaxFilter();
            $(window).trigger('ajaxLoadItemsSpecial:success');
        },
        error: function(xhr, status, error) {
            var err = "(" + xhr.responseText + ")";
            $(window).trigger('ajaxLoadItemsSpecial:error');
        }
    });

}



// WEBPACK FOOTER //
// ./static/js/modules/ajax-load-items.js